import BaseApi from 'api/core/baseApi';
import { ENDPOINTS } from 'api/config/endpoints';

class ManifestApi extends BaseApi {
  constructor() {
    super(ENDPOINTS.MANIFEST);
  }

  getShipmentsOfManifest(manifestId, params = new URLSearchParams()) {
    const queryString = params.toString();
    const url = queryString
      ? `${this.getResourceUrl()}${manifestId}/shipments/?${queryString}`
      : `${this.getResourceUrl()}${manifestId}/shipments/`;

    return this.httpClient.get(url);
  }

  addShipmentToManifest(manifestId, barcode) {
    return this.httpClient.patch(
      `${this.getResourceUrl()}${manifestId}/shipment-add/`,
      { barcode: barcode },
    );
  }

  removeShipmentFromManifest(manifestId, shipmentId) {
    return this.httpClient.patch(
      `${this.getResourceUrl()}${manifestId}/shipment-remove/`,
      {
        shipment: shipmentId,
      },
    );
  }

  closeManifest(manifestId) {
    return this.httpClient.patch(
      `${this.getResourceUrl()}${manifestId}/close/`,
      {},
    );
  }

  discardManifest(manifestId) {
    return this.httpClient.delete(`${this.getResourceUrl()}${manifestId}/`);
  }

  exportManifest(params = new URLSearchParams()) {
    const queryString = params.toString();
    const url = queryString
      ? `${this.getResourceUrl()}export/?${queryString}`
      : `${this.getResourceUrl()}export/`;

    return this.httpClient.get(url);
  }
}

export default new ManifestApi();
